import { render, staticRenderFns } from "./WarehousesExportToCRMForm.vue?vue&type=template&id=bebe6aa8&"
import script from "./WarehousesExportToCRMForm.vue?vue&type=script&lang=ts&"
export * from "./WarehousesExportToCRMForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports